'use strict';

import {debounce} from '../utils/debounce';

const callbacks = [];
let previousScrollPosition;

function processScroll() {
	const eventData = {};
	eventData.scrollTop = window.pageYOffset;

	eventData.isAtTop = eventData.scrollTop <= 0;

	if (eventData.scrollTop > previousScrollPosition) {
		eventData.scrollDirection = 'down';
	} else if (eventData.scrollTop < previousScrollPosition) {
		eventData.scrollDirection = 'up';
	}

	for (let index = 0; index < callbacks.length; index++) {
		const callback = callbacks[index];
		callback(eventData);
	}

	previousScrollPosition = eventData.scrollTop;
}

const onScroll = debounce(processScroll, 100, true);

export default {
	onScroll: function(func) {
		if ($.isFunction(func)) {
			callbacks.push(func);
		}
	},

	start: function() {
		previousScrollPosition = window.pageYOffset;
		$(window).off('scroll.scrollWatcher').on('scroll.scrollWatcher', function () {
			onScroll();
		});
	}
};